import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import useTranslation from '../../hooks/useTranslation';

interface UserInfo {
  name: string;
  email: string;
  company: string;
}

interface UserInfoFormProps {
  userInfo: UserInfo;
  onUserInfoChange: (userInfo: UserInfo) => void;
}

const UserInfoForm: React.FC<UserInfoFormProps> = ({
  userInfo,
  onUserInfoChange,
}) => {
  const { t } = useTranslation();
  const handleFieldChange =
    (field: keyof UserInfo) => (event: React.ChangeEvent<HTMLInputElement>) => {
      onUserInfoChange({
        ...userInfo,
        [field]: event.target.value,
      });
    };

  return (
    <Box>
      <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
        {t('contact.booking.userInfo.title')}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          label={t('contact.booking.userInfo.name')}
          value={userInfo.name}
          onChange={handleFieldChange('name')}
          required
          fullWidth
        />
        <TextField
          label={t('contact.booking.userInfo.email')}
          type="email"
          value={userInfo.email}
          onChange={handleFieldChange('email')}
          required
          fullWidth
        />
        <TextField
          label={t('contact.booking.userInfo.company')}
          value={userInfo.company || ''}
          onChange={handleFieldChange('company')}
          fullWidth
        />
      </Box>
    </Box>
  );
};

export default UserInfoForm;
